import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

const ProvinceSelectModal = ({ open, onClose, onSelect, selectedValue }) => {
  // Liste des provinces du Gabon
  const provinces = [
    { id: "estuaire", name: "Estuaire" },
    { id: "haut-ogooue", name: "Haut-Ogooué" },
    { id: "moyen-ogooue", name: "Moyen-Ogooué" },
    { id: "ngounie", name: "Ngounié" },
    { id: "nyanga", name: "Nyanga" },
    { id: "ogooue-ivindo", name: "Ogooué-Ivindo" },
    { id: "ogooue-lolo", name: "Ogooué-Lolo" },
    { id: "ogooue-maritime", name: "Ogooué-Maritime" },
    { id: "woleu-ntem", name: "Woleu-Ntem" },
  ];

  const handleSelect = (provinceId) => {
    onSelect(provinceId);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: "8px",
          width: "90%",
          maxWidth: "400px",
          maxHeight: "80vh",
          overflow: "auto",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Sélectionnez une province
        </Typography>

        <List sx={{ mb: 2 }}>
          {provinces.map((province) => (
            <ListItem key={province.id} disablePadding>
              <ListItemButton
                onClick={() => handleSelect(province.id)}
                selected={selectedValue === province.id}
                sx={{
                  borderRadius: "4px",
                  mb: 1,
                  bgcolor: selectedValue === province.id ? "primary.light" : "background.paper",
                  "&:hover": {
                    bgcolor: "primary.light",
                  },
                }}
              >
                <ListItemText primary={province.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          fullWidth
          sx={{ mt: 1 }}
        >
          Annuler
        </Button>
      </Box>
    </Modal>
  );
};

export default ProvinceSelectModal;